import React from 'react';
import { withTranslation } from "react-i18next";
import axios from 'axios';
import {
  krdetailConstants,
  krdetailMetricConst,
} from './../../../constants/krdetails.constants';
import { reactLoader, removeReactLoader } from '../../../utils/common';
import { loadFederatedModule } from '../../../utils/loadFederatedModule';
import GoalServices from '../../../services/goal.services';
import { ThemeProvider, Modal } from '@workboard/wobo-ui';
import { getExternalAppIdByKpiType, resolveKrSaveGoalId } from './../../../utils/kpi-market-place-util';
import RetainUpdateModal from '../../../components/retainUpdateModal.component';
import {
  appendAddOkrData,
  appendInitialData,
  appendItemData,
  appendLastSourceTypeData,
  buildV2WizardPayloadFromDataSource,
  buildV2WizardPayloadFromKpiData,
  isExternalMetricV2AppId,
  KPI_IFRAME_NUMBER_TOTAL_TARGET_APP_IDS,
  KPI_IFRAME_PERCENT_TOTAL_TARGET_APP_IDS,
  normalizeDataSourceMessage,
  normalizeKpiDataMessage,
  toWizardOwnerId,
} from '../../../utils/kpi-v2-wizard-payload';

const modalTitle = 'Select integration';
class KpiMarketPlaceKrWizardPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeWidth: '750px',
      iframeHeight: '512px',
      item: this.props.item,
      lastSourceType: this.props.item && this.props.item.source ? this.props.item.source : '',
      title: modalTitle,
      savedMetric: null,
      purgeConfirmModal: null,
      purgeConfirmSelectedType: '',
    };
    this.handleMessage = this.handleMessage.bind(this);
    this.getUpdateFrequencyByInternal = this.getUpdateFrequencyByInternal.bind(this);
    this.getUserAccessToken = this.getUserAccessToken.bind(this);
    this.handleSaveCompletion = this.handleSaveCompletion.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
    this.exitIntegrationPurgeConfirmModal = this.exitIntegrationPurgeConfirmModal.bind(this);
    this.confirmIntegrationPurge = this.confirmIntegrationPurge.bind(this);
    this.changeIntegrationRetainRadio = this.changeIntegrationRetainRadio.bind(this);
  }

  async componentDidMount() {
    if (document.querySelector('.goalPopupNew')) {
      document.querySelector('.goalPopupNew').style['z-index'] = 1000;
    }
    window.addEventListener('message', this.handleMessage);
  }

  async getUserAccessToken(clientId) {
    const res = await axios.get(`${wbConfig.baseUrl}/client/generateUserAccessToken?client_id=${clientId}`);
    return res?.data;
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  getUpdateFrequencyByInternal(item) {
    const cadences = Object.assign({}, krdetailMetricConst);
    if (cadences.hasOwnProperty(+item.interval)) {
      return cadences[+item.interval];
    }
    return ''
  }

  getWizardAppendContext() {
    return {
      item: this.props.item,
      addOkrData: this.props.addOkrData,
      isChildKr: this.props.isChildKr,
      fromParentKr: this.props.fromParentKr,
      mitChildKr: this.props.mitChildKr,
      mitIndex: this.props.mitIndex,
      mitType: this.props.mitType,
      getProgressType: this.props.getProgressType,
      basicInlineData: this.props.basicInlineData,
      goalDetails: this.props.goalDetails,
      realOwner: this.props.realOwner,
      parent: this.props.parent,
    };
  }

  applyWizardAppendPipeline(payload, integrationSource, externalApp) {
    const context = this.getWizardAppendContext();

    if (externalApp?.kpiType) {
      payload = appendInitialData(payload, context);
    }

    if (this.props.item) {
      payload = appendItemData(payload, integrationSource, context);
    } else if (this.props.addOkrData?.goalDetails?.all_metrics == 1) {
      payload = appendAddOkrData(payload, context);
    }

    if (this.state.lastSourceType == 1) {
      payload = appendLastSourceTypeData(payload);
    }

    return payload;
  }

  buildV2KpiWizardPayload(clientId, userConnection, childData, externalApp) {
    const metricName = this.getMetricNameInputValue();
    const metricDescription = this.getMetricDescriptionInputValue();
    if (metricName == '') {
      this.props?.showMetricNameErr();
      return null;
    }

    const externalAppId = getExternalAppIdByKpiType(externalApp.kpiType);
    const realOwnerId = toWizardOwnerId(
      this.props.realOwner ? this.props.realOwner.id : this.props.item?.real_owner,
    );
    const parent = toWizardOwnerId(this.props.parent || this.props.item?.parent);
    const baseInput = {
      clientId,
      userConnection,
      externalAppId: Number(externalAppId),
      metricName,
      metricDescription,
      realOwnerId,
      parent,
    };

    let payload;
    let integrationSource;
    if (childData.kpiData) {
      const kpiData = normalizeKpiDataMessage(childData.kpiData);
      payload = buildV2WizardPayloadFromKpiData({
        ...baseInput,
        kpiData,
      });
      integrationSource = kpiData;
    } else {
      const dataSource = normalizeDataSourceMessage(childData.dataSource);
      payload = buildV2WizardPayloadFromDataSource({
        ...baseInput,
        dataSource,
        kpiDataId: childData.kpiDataId,
      });
      integrationSource = dataSource;
    }

    payload = this.applyWizardAppendPipeline(payload, integrationSource, externalApp);

    // eslint-disable-next-line no-console -- dev
    console.log('[kpiKrWizard] buildV2KpiWizardPayload', { externalAppId, payload });

    return payload;
  }

  buildSalesforcePaylaod(clientId, userConnection, dataSource, externalApp, kpiDataId) {
    const metricName = this.getMetricNameInputValue();
    const metricDescription = this.getMetricDescriptionInputValue();
    if (metricName == '') {
      this.props?.showMetricNameErr();
      return null;
    }

    const projectObj = { name: dataSource.name || dataSource.id,  id: dataSource.id, type: dataSource.type };
    const externalAppId = getExternalAppIdByKpiType(externalApp.kpiType);

    let metricType = 'number';
    if (dataSource?.extraData?.dataType === 'percent' || dataSource?.data?.dataType === 'percent') {
      metricType = 'percent';
    }

    let payload =  {
      clearCache: true,
      ext_app_id: externalAppId,
      source: 8,
      achieve_target : dataSource.data.value,
      real_owner: this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner,
      owner: this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner,
      name: metricName,
      description: metricDescription,
      parent: this.props.parent || this.props.item?.parent,
      instance_url: userConnection.externalInstanceUrl,
      project_ids: [JSON.stringify(projectObj)],
      ext_source_data: {
        ...dataSource.extraData,
        ...{ value: dataSource.data.value, valueLabel: dataSource.data.label, automateTargetFlag: dataSource.automateTargetFlag}
      },
      external_app_sources: {
        ...{id: kpiDataId},
        ...dataSource.extraData,
        ...{
          value: dataSource.data.value,
          valueLabel: dataSource.data.label,
          automateTargetFlag: dataSource.automateTargetFlag,
          external_app_id : externalAppId,
          instance_url: userConnection.externalInstanceUrl,
          ext_app_link_name : dataSource.extraData.workbookName,
          ext_app_link_type : projectObj['type'],
          ext_app_link_id : projectObj['id'],
        }
      },
      ext_source_unit: {
        metric: metricType,
        progress: dataSource.data.value,
        target: metricType === 'percent' ? 100: (dataSource.data.total || 0)
      },
      ext_source_string: clientId,
      connectionUrn: userConnection.connectionUrn
    };

    payload = this.applyWizardAppendPipeline(payload, dataSource, externalApp);

    if (metricType === 'number') {
      payload.metric = '1'; // number
      if (KPI_IFRAME_NUMBER_TOTAL_TARGET_APP_IDS.includes(Number(externalAppId))) {
        payload.target = dataSource.data.total;
      }
    }
    if (metricType === 'percent') {
      payload.metric = '3'; // percent
      if (KPI_IFRAME_PERCENT_TOTAL_TARGET_APP_IDS.includes(Number(externalAppId))) {
        payload.target = dataSource.data.total;
      } else if (Number(externalAppId) === krdetailConstants.JIRA_KPI_ID && typeof dataSource?.data?.total !== 'undefined' && dataSource?.automateTargetFlag) {
        payload.target = dataSource.data.total;
      } else { // for JIRA
        payload.target = '100';
      }
    } else if (typeof dataSource?.data?.total !== 'undefined' && dataSource?.automateTargetFlag) {
      payload.target = dataSource.data.total;
    }

    // eslint-disable-next-line no-console -- dev: only runs when iframe uses dataSource path (no kpiData)
    console.log('[kpiKrWizard] buildSalesforcePaylaod payload', {
      externalAppId,
      metricType,
      dataSourceKeys: dataSource ? Object.keys(dataSource) : [],
      payload,
    });

    return payload;
  }

  getMetricNameInputValue() {
    let metricName = $('#metric-name-text').val();
    // in case a child kr, the page has two input with the same id. (bad practice)
    if (this.props.isChildKr && this.props.fromParentKr) {
      metricName = document.querySelectorAll('#metric-name-text')[1]?.value;
    }
    metricName = this.props.item['name'] ? this.props.item['name'] : metricName;

    return metricName;
  }

  getMetricDescriptionInputValue() {
    let metricDescription = $("#metric-name-note").val();
    // in case a child kr, the page has two input with the same id. (bad practice)
    if (this.props.isChildKr && this.props.fromParentKr) {
      metricDescription = document.querySelectorAll('#metric-name-note')[1]?.value;
    }

    return metricDescription;
  }

  buildKpiConnectorPayload(childData) {
    if (!childData.dataSource && !childData.kpiData) {
      return null;
    }

    if (!childData.userConnection) {
      return null;
    }

    const externalAppId = getExternalAppIdByKpiType(childData.externalSource?.kpiType);
    if (isExternalMetricV2AppId(Number(externalAppId))) {
      // eslint-disable-next-line no-console -- dev
      console.log('[kpiKrWizard] save path → buildV2KpiWizardPayload', { externalAppId });
      return this.buildV2KpiWizardPayload(
        childData.clientId,
        childData.userConnection,
        childData,
        childData.externalSource,
      );
    }

    // KPI iframe (incl. MS Planner) normally posts kpiData → buildKpiDataMetricPayload.
    // buildSalesforcePaylaod runs only when the iframe sends dataSource without kpiData (e.g. some Salesforce-style flows).
    if (childData.kpiData) {
      // eslint-disable-next-line no-console -- dev: which builder ran (remove if noisy)
      console.log('[kpiKrWizard] save path → buildKpiDataMetricPayload', { hasKpiData: true });
      return this.buildKpiDataMetricPayload(childData.clientId, childData.userConnection, childData.kpiData, childData.externalSource);
    }
    // eslint-disable-next-line no-console -- dev: which builder ran (remove if noisy)
    console.log('[kpiKrWizard] save path → buildSalesforcePaylaod', { hasDataSource: !!childData.dataSource });
    return this.buildSalesforcePaylaod(childData.clientId, childData.userConnection, childData.dataSource, childData.externalSource, childData?.kpiDataId);
  }

  buildKpiDataMetricPayload(clientId, userConnection, kpiData, externalApp) {
    const isGitlabPercent = (externalApp?.kpiType === 'gitlab' && (kpiData?.externalObjectExtra?.selectedProgress?.id === 'percentCompletedIssues' || kpiData?.externalObjectExtra?.selectedProgress?.id === 'percentCompletedWeight'));
    const metricName = this.getMetricNameInputValue();
    const metricDescription = this.getMetricDescriptionInputValue();
    if (metricName == '') {
      this.props?.showMetricNameErr();
      return false;
    }

    const externalAppId = getExternalAppIdByKpiType(externalApp.kpiType);
    const projectObj = { name: kpiData.externalObjectName || kpiData._id,  id: kpiData._id, type: 'kpi' };
    const metricType = (kpiData.data.dataType === 'percent') ? 'percent': 'number';

    // eslint-disable-next-line no-console -- dev: KPI connector path
    console.log('[kpiKrWizard] buildKpiDataMetricPayload projectObj', projectObj);
    let payload = {
      clearCache: true,
      ext_app_id: externalAppId,
      source: 8,
      achieve_target: kpiData.data.value,
      real_owner: this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner,
      owner: this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner,
      name: metricName,
      description: metricDescription,
      parent: this.props.parent || this.props.item?.parent,
      instance_url: userConnection.externalInstanceUrl,
      project_ids: [JSON.stringify(projectObj)],
      ext_source_data: {
        kpiDataId: kpiData._id,
        connectorId: kpiData?.externalObjectExtra?.connectorId,
        webUrl: kpiData?.externalObjectExtra?.webUrl
      },
      external_app_sources: {
        ...{ id: kpiData._id },
        ...{
          external_app_id: externalAppId,
          instance_url: userConnection.externalInstanceUrl,
          automateTargetFlag: kpiData.automateTargetFlag,
          ext_app_link_name : projectObj['name'],
          ext_app_link_type : projectObj['type'],
          ext_app_link_id : projectObj['id'],
        }
      },
      ext_source_unit: {
        metric: metricType,
        progress: kpiData.data.value,
        target: kpiData.data.total || 0
      },
      ext_source_string: clientId,
      connectionUrn: userConnection.connectionUrn
    };

    payload = this.applyWizardAppendPipeline(payload, kpiData, externalApp);

    if (isGitlabPercent) {
      payload.metric = '3'; // percent
      payload.target = '100';
    } else if (metricType == 'number' && (externalAppId == 42 || externalAppId == 44)) {
      // For MS Planner (42) number-based KPIs,
      payload.metric = '1';
      if (typeof kpiData?.data?.total !== 'undefined' && kpiData.automateTargetFlag !== false) {
        payload.target = kpiData.data.total;
      }
    } else if (metricType == 'percent' && (externalAppId == 42 || externalAppId == 44)) {
      // For MS Planner (42) percent-based KPIs,
      payload.metric = '3'; // percent
      if (typeof kpiData?.data?.total !== 'undefined' && kpiData.automateTargetFlag !== false) {
        payload.target = kpiData.data.total;
      }
    }
    // eslint-disable-next-line no-console -- dev: KPI connector path
    console.log('[kpiKrWizard] buildKpiDataMetricPayload payload', payload);
    return payload;
  }

  applyRetainUpdatesToPayload(payload, childData) {
    if (!payload || !childData?.retainUpdates) {
      return payload;
    }
    return {
      ...payload,
      retainUpdates: childData.retainUpdates,
    };
  }

  isMetricWoboObjectFromMessage(messageArgs) {
    const parentObject = messageArgs?.parent;
    return parentObject?.woboObjectType === 'metric' && Boolean(parentObject?.woboObjectId);
  }

  postMessageToIframe(func, args, origin) {
    const frame = document.getElementById('wobo-external-app-container');
    if (!frame?.contentWindow) {
      return;
    }
    frame.contentWindow.postMessage({ id: 0, func, args: args || {} }, origin || '*');
  }

  exitIntegrationPurgeConfirmModal() {
    const { purgeConfirmModal } = this.state;
    if (purgeConfirmModal) {
      this.postMessageToIframe('integration-purge-cancelled', {
        confirmMessageId: purgeConfirmModal.confirmMessageId,
      }, purgeConfirmModal.origin);
    }
    this.setState({ purgeConfirmModal: null, purgeConfirmSelectedType: '' });
  }

  changeIntegrationRetainRadio(value) {
    this.setState({ purgeConfirmSelectedType: value });
  }

  confirmIntegrationPurge() {
    const { purgeConfirmModal, purgeConfirmSelectedType } = this.state;
    if (purgeConfirmModal && purgeConfirmSelectedType) {
      this.postMessageToIframe('integration-purge-confirmed', {
        confirmMessageId: purgeConfirmModal.confirmMessageId,
        retainUpdates: Number(purgeConfirmSelectedType),
      }, purgeConfirmModal.origin);
    }
    this.setState({ purgeConfirmModal: null, purgeConfirmSelectedType: '' });
  }


  /**
   * Saves the key result if all params are valid
   */
  handleSave (childData) {
    reactLoader();
    const payload = this.applyRetainUpdatesToPayload(this.buildKpiConnectorPayload(childData), childData);    
    const goalId = resolveKrSaveGoalId(this.props.item, this.props.addOkrData?.goalDetails);
    if (payload && goalId) {
      const goalService = new GoalServices();

      return goalService
        .addEditKr({ goalId: goalId, metric: payload })
        .then(res => {
          if (res && res.data.data) {
            if (!this.props.onlyMetEdit && this.props.actions && this.props.actions.addNewKr) {

              if (!this.props.isChildKr && !this.props.fromParentKr) {
                this.props.actions.addNewKr(res.data.data);
              }

              if (this.props.closeKrRightPane && !this.props.saveKrComplete) {
                this.props.closeKrRightPane(true)
              }
            }
          }
          removeReactLoader();
          // eslint-disable-next-line no-console -- dev
          console.log('[kpiKrWizard] handleSave addEditKr payload', payload);
          const returnMetric = res.data.data;
          returnMetric.achieve_target = payload.achieve_target??0;
          console.log('returnMetric', returnMetric);
          return returnMetric;
        });
    } else {
      removeReactLoader();
    }
  }

  handleSaveCompletion(metric) {
    if (this.props.isChildKr && this.props.fromParentKr) {
      metric = { ... metric, ... { ignoreIdCheck: true } };
      this.props.saveNestedKr(metric, this.props.nestedKrIndex, this.props.nestedKrAction);
    } else if(this.props.mitChildKr){
      this.props.saveQuarterlyKR(metric, this.props.mitIndex);
      this.props.closePopUp();
    } else {
      this.props.saveKrComplete(metric);
    }
  }

  createMessagePayload(func, item, woboToken) {
    const kpiType = this.props.kpiType || null;

    const okrDateRange = {start: this.props.goalDetails.start_date, end: this.props.goalDetails.target_date, name: ''};
    const filterOption = this.props.goalDetails.filterOption;
    const filterOptionArray = [];

    Object.keys(filterOption).forEach(key => filterOptionArray.push(filterOption[key]));

    const quarterData = filterOptionArray.filter((item) => {
      return moment.utc(item.start).format("X") === moment.utc(okrDateRange.start).format("X") && moment.utc(item.end).format("X") === moment.utc(okrDateRange.end).format("X");
    });

    if (quarterData?.[0] && quarterData?.[0]?.name) {
      okrDateRange.name = quarterData[0].name;
    }

    return woboClients.createMessage(func, {
      woboObjectId: item ? item.id : null,
      woboObjectType: 'metric',
      updateFrequency: item ? this.getUpdateFrequencyByInternal(item) : null,
      integrationsFeatureFlag: this.props.integrations,
      isEnhancedPowerBIEnabled: wbConfig.isEnhancedPowerBIEnabled ?? false,
      selectedExternalApp: { kpiType },
      woboToken,
      okrDateRange,
    });
  }

  handleMessage(event) {
    if (!event.data || !event.data.func) {
      console.log('Message has no func property, ignoring');
      return;
    }
    const frame = document.getElementById('wobo-external-app-container');
    // once message is received, we need to send the message back to child
    // console.log(`Sending message to origin: ${event.origin}`);
    switch (event.data.func) {
      case "initialize":
        const child = event.data?.args?.child;
        this.getUserAccessToken(child.clientId).then((woboToken) => {
          frame.contentWindow.postMessage(this.createMessagePayload(event.data.func, this.state.item, woboToken), event.origin);
        });
        break;
      case "okr-wizard-clicked":
        const externalSource = event.data.args.child.externalSource;
        // these external source is handled by the wizard itself.
        if (externalSource && externalSource.isLegacy && this.props.continue) {
          this.props.continue(externalSource);
        }
        break;
      case "iframe-resize":
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        const height = Math.min(vh - 120, parseInt(event.data.args.child.iframeSize.height));
        console.log('height', height);
        this.setState({ iframeWidth: event.data.args.child.iframeSize.width, iframeHeight: height + 'px' });
        break;
      case "cancelled":
        this.props.closePopUp();
        break;
      case "success":
        console.log('success', event);
        if(this.props.mitChildKr){
          const payload = this.applyRetainUpdatesToPayload(
            this.buildKpiConnectorPayload(event.data.args.child),
            event.data.args.child,
          );
          // console.log("external_app_sources", payload);
          if (payload && typeof payload === 'object') {
            payload.clientId = event.data.args.child.clientId;
            payload.external_app_sources.data = JSON.stringify(payload.external_app_sources);
            payload.kpiDataId = event.data.args.child?.kpiDataId;
            payload.isNew = event.data.args.child.isNew;
            this.props.saveQuarterlyKR(payload, this.props.mitIndex);
          }
          this.props.closePopUp();
        } else {
          this.handleSave(event.data.args.child).then(async (metric) => {
            metric.startDateText = this.props.basicInlineData?.duration?.start || this.props.item?.duration?.start;
            metric.endDateText = this.props.basicInlineData?.duration?.end || this.props.item?.duration?.end;

            const childArgs = event.data.args.child;
            const agentSubscription = childArgs?.agentSubscription;
            const continueWithCompletion = async (m, patchedObjectId) => {
              if (agentSubscription) {
                // Close the iframe modal visually by setting savedMetric,
                // keeping the component mounted so we can await the subscription portal
                await new Promise((resolve) => this.setState({ item: m, savedMetric: m }, resolve));
                reactLoader();
                try {
                  const { triggerAgentSubscription } = await loadFederatedModule('WF/AgentSubscription');
                  const subscriptionPayload = patchedObjectId
                    ? { ...agentSubscription, objectId: parseInt(patchedObjectId, 10), objectName: m.name }
                    : agentSubscription;
                  await triggerAgentSubscription(subscriptionPayload);
                } catch (e) {
                  console.warn('AgentSubscription could not be loaded', e);
                } finally {
                  removeReactLoader();
                }
              } else {
                this.setState({ item: m });
              }
              this.handleSaveCompletion(m);
            };

            const kpiDataIdToLink = childArgs?.kpiDataId || childArgs?.kpiData?._id;
            const shouldLinkKpiData = childArgs?.isNew !== false && kpiDataIdToLink && metric?.id;

            if (shouldLinkKpiData) {
              const goalService = new GoalServices();
              const access_token = event.data.args.parent?.woboToken?.access_token;
              try {
                await goalService.patchKpiData(
                  kpiDataIdToLink,
                  { woboObjectId: metric.id },
                  { access_token },
                );
              } catch (patchError) {
                console.warn('[kpiKrWizard] patchKpiData failed', patchError);
              }
              await continueWithCompletion(metric, metric.id);
            } else if (childArgs?.isNew !== undefined && childArgs.isNew === false) {
              await continueWithCompletion(metric);
            } else {
              this.setState({ item: metric });
              //send metric to child to register the newly create metric
              frame.contentWindow.postMessage(this.createMessagePayload('save-kpi-data', metric), event.origin);
            }
          });
        }
        break;
      case "done":
        this.handleSaveCompletion(this.state.item);
        break;
      case "iframe-modal-header-change":
        // here title and close action will be changed for powerbi reports
        const eventData = event.data?.args.child;
        const { modalDetails: { action, title } } = eventData || {};
        const mTitle = action == 'change' ? title : modalTitle;
        this.setState({title: mTitle});
        break;
      case "integration-purge-confirm": {
        const { t } = this.props;
        if (!this.isMetricWoboObjectFromMessage(event.data.args)) {
          this.postMessageToIframe('integration-purge-cancelled', {
            confirmMessageId: event.data.args?.child?.confirmMessageId,
          }, event.origin);
          break;
        }
        this.setState({
          purgeConfirmModal: {
            confirmMessageId: event.data.args.child.confirmMessageId,
            title: event.data.args.child.purgeConfirmTitle || t('Save key result integration with new configuration'),
            content: event.data.args.child.purgeConfirmContent
              || t('Are you sure you want to save this key result integration with the configuration selected?'),
            origin: event.origin,
          },
          purgeConfirmSelectedType: '',
        });
        break;
      }
      default:
        console.log('Unknown event: %o', event);
    }
  }

  onClosePopup() {
    const { title } = this.state;
    if (title != modalTitle) {
      const frame = document.getElementById('wobo-external-app-container');
      frame.contentWindow.postMessage({ type: 'CLOSE_REPORT_MODAL' }, '*');
    } else {
      this.props?.closePopUp?.();
    }
  }

  render() {
    // When savedMetric is set, the KR has been saved and we're awaiting the
    // agent subscription portal. Keep the component mounted (so the async chain
    // can continue) but hide the modal so the portal renders unobstructed.
    if (this.state.savedMetric) {
      return null;
    }

    return (
      <ThemeProvider>
        {this.state.purgeConfirmModal && (
          <RetainUpdateModal
            selectedType={this.state.purgeConfirmSelectedType}
            changeRadio={this.changeIntegrationRetainRadio}
            exitDeleteModal={this.exitIntegrationPurgeConfirmModal}
            deleteItems={this.confirmIntegrationPurge}
            titleRetain={this.state.purgeConfirmModal.title}
            contentRetain={this.state.purgeConfirmModal.content}
          />
        )}
        <Modal
          isOpen={true}
          submitOnly={true}
          className="kpi-market-place-integrations-modal"
          title={this.state.title}
          actions={() => null}
          onDismiss={this.onClosePopup}
          style={{ zIndex: 1000000 }}
        >
          <div
            className="kpi-market-place-kr-wizard-modal"
            style={{ width: this.state.iframeWidth, height: this.state.iframeHeight, maxHeight: '81vh' }}
          >
            {
              <iframe
                id="wobo-external-app-container"
                src={`${wbConfig.kpiUrl}/client/okr-wizard`}
                style={{ width: 'inherit', height: 'inherit' }}
              />
            }
          </div>
        </Modal>
      </ThemeProvider>
    );
  }
}

export default withTranslation()(KpiMarketPlaceKrWizardPopup);
